import { Form, Formik, Field, ErrorMessage } from "formik";
import React from "react";
import firebase from "../firebase";
import { ProfileProps } from "./Profile";
import { Errors } from "../typings/interfaces";
import { useHistory } from "react-router";
import { FormikReactSelect } from "../common/FormikReactSelect";

const db = firebase.firestore();

export const ProfileEdit = ({ user, profile }: ProfileProps) => {
  const history = useHistory();

  const year = (new Date()).getFullYear();
  const yearsOptions = Array.from(new Array(20),(val, index) => ({
    label: `${year - index}`,
    value: `${year - index}`,
  }));

  const revenueOptions = [
    {
      label: "$0M-$1M",
      value: "$0M-$1M",
    },
    {
      label: "$1M-$10M",
      value: "$1M-$10M"
    },
    {
      label: "$10M-$100M",
      value: "$10M-$100M",
    },
    {
      label: "$100M+",
      value: "$100M+"
    },
  ];

  return (
    <div className="profile-form">
      <h2>Edit Profile</h2>
      <Formik
        initialValues={{
          name: profile.name,
          tag_line: profile.tag_line,
          story: profile.story,
          revenue: profile.revenue,
          city: profile.city,
          type: profile.type,
        }}
        validate={(values) => {
          const errors: Errors = {};
          if (!values.name) {
            errors.name = "Required";
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          const update = Object.assign({}, values, {
            uid: user.uid,
          });
          db.collection("profiles").doc(user.uid).set(update, { merge: true });
          history.push("/");
        }}
      >
        {({ isSubmitting }) => (
          <Form className="profile-form">
            <Field
              as={FormikReactSelect}
              name="type"
              placeholder="Account Type"
              options={[
                { label: "Buyer", value: "buyer" },
                { label: "Vendor", value: "vendor" },
                { label: "Broker", value: "broker" },
              ]}
            />
            <ErrorMessage name="type" component="div" />
            <Field type="text" name="name" placeholder="Brand Name" />
            <ErrorMessage name="name" component="div" />
            <Field type="text" name="tag_line" placeholder="Tag Line" />
            <ErrorMessage name="tag_line" component="div" />
            <Field
              as="textarea"
              type="text"
              name="story"
              placeholder="Tell your story"
            />
            <ErrorMessage name="story" component="div" />
            <Field type="text" name="city" placeholder="City" />
            <ErrorMessage name="city" component="div" />

            <Field
              as={FormikReactSelect}
              name="revenue"
              placeholder="Approximate Annual Revenue"
              options={revenueOptions}
            />
            <ErrorMessage name="revenue" component="div" />

            <Field
              as={FormikReactSelect}
              name="year"
              placeholder="Year Founded"
              options={yearsOptions}
            />
            <ErrorMessage name="year" component="div" />

            <button className="button" type="submit" disabled={isSubmitting}>
              Save
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};
